import { css } from '@emotion/core';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

const item = css`
  ${styleUtils.flex.container()};
  background-color: ${theme.color.white};

  &:hover {
    background-color: ${theme.color.designSystem.background.grey.hover};
  }

  &:focus {
    background-color: ${theme.color.designSystem.background.grey.focus};
  }
`;

const highlighted = css`
  background-color: ${theme.color.designSystem.background.grey.focus};
`;

const itemDraggedBefore = css`
  border-top: 4px solid
    ${styleUtils.color.opacity({ color: 'purple', alpha: 'alpha28' })};
`;
const itemDraggedAfter = css`
  border-bottom: 4px solid
    ${styleUtils.color.opacity({ color: 'purple', alpha: 'alpha28' })};
`;

const itemDragging = css`
  opacity: ${theme.opacity.alpha40};
`;

const itemSmall = css`
  padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
`;

const itemMedium = css`
  padding: ${theme.spacing.small};
`;

const itemLarge = css`
  padding: ${theme.spacing.medium};
`;

const text = css`
  ${styleUtils.typography.copy({ weight: 'regular', lineHeight: 'large' })};
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
`;

const textAfterDecoration = css`
  margin-left: ${theme.spacing.medium};
`;

const truncate = css`
  flex: 1;
  margin-top: 0;
  margin-bottom: 0;
  ${styleUtils.typography.truncate()};
`;

export default {
  item: {
    base: item,
    draggedOverByType: {
      before: itemDraggedBefore,
      after: itemDraggedAfter,
    },
    dragging: itemDragging,
    bySize: {
      small: itemSmall,
      medium: itemMedium,
      large: itemLarge,
    },
    highlighted,
  },
  text: {
    base: text,
    truncate,
    afterDecoration: textAfterDecoration,
  },
};
